export default {
    
    find:               { method: 'get',    url: 'bank_data' },
    create:             { method: 'post',   url: 'bank_data'},
    update:             { method: 'put',    url: 'bank_data/{id}'},
    delete:             { method: 'delete', url: 'bank_data/{id}'},
    findAccountType:    { method: 'get',    url: 'bank_data/account/types' },
    findPixType:        { method: 'get',    url: 'bank_data/pix/types' },
}